/* jshint ignore:start */
import axios from "axios";

export default axios.create({
  baseURL: `https://api.unsplash.com/`,
  headers: {
    Authorization: "Client-ID x2RGQrvkUynugudkLctCKsj89_g_qjgF3JjEJWvdbws",
  },
});